import { Button, cn } from "@base/ui";
import { RefreshCw } from "lucide-react";
import { useConexaoKommo, useSincronizarKommo } from "../application/conexoes.contexto";

/**
 * "Sincronizar" do Kommo para usar fora de Conexoes (ex.: no Dashboard). So
 * aparece com o Kommo conectado e mapeado; o andamento aparece no toast.
 */
export function BotaoDeSincronizarKommo({ clienteId }: { readonly clienteId: string }) {
  const conexao = useConexaoKommo(clienteId);
  const sincronizar = useSincronizarKommo(clienteId);
  if (!conexao.data?.mapeamento) return null;
  const sincronizando = conexao.data.situacao === "sincronizando" || sincronizar.isPending;

  return (
    <Button
      variant="outline"
      className="h-11 gap-2 rounded-full px-4"
      disabled={sincronizando}
      onClick={() => sincronizar.mutate()}
      title="Trazer agora as novidades do Kommo"
    >
      <RefreshCw className={cn(sincronizando && "animate-spin")} aria-hidden="true" />
      {sincronizando ? "Sincronizando…" : "Sincronizar"}
    </Button>
  );
}
